/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Title_AccentInputs */

const tr_landing_pricerules_title_accent = /** @type {(inputs: Landing_Pricerules_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fiyatlarınız da oynasın`)
};

const en_landing_pricerules_title_accent = /** @type {(inputs: Landing_Pricerules_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your prices move too`)
};

const de_landing_pricerules_title_accent = /** @type {(inputs: Landing_Pricerules_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`schwanken Ihre Preise mit`)
};

const ru_landing_pricerules_title_accent = /** @type {(inputs: Landing_Pricerules_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`пусть меняются и цены`)
};

/**
* | output |
* | --- |
* | "your prices move too" |
*
* @param {Landing_Pricerules_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_title_accent = /** @type {((inputs?: Landing_Pricerules_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_title_accent(inputs)
	if (locale === "de") return de_landing_pricerules_title_accent(inputs)
	if (locale === "ru") return ru_landing_pricerules_title_accent(inputs)
	return tr_landing_pricerules_title_accent(inputs)
});